import { useMemo, useState } from 'react'
import { isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'
import { putSPDataWithParams } from 'src/supportPortal/services/services'
import { APPROVAL_APIS, buildServiceDetailsMap, DISAPPROVAL_APIS } from '../utils/approvalUtils'

export const APPROVAL_DISAPPROVAL_DIALOG_TYPES = {
  APPROVE: 'approve',
  DISAPPROVE: 'disapprove',
}

export const useApprovalDialog = ({ onSuccess, onError }) => {
  const [dialogState, setDialogState] = useState({
    open: false,
    practitioner: null,
    approvalRole: null,
    actionType: null,
    loading: false,
  })

  console.log({ dialogState })

  const openDialog = (practitioner, approvalRole, actionType) => {
    setDialogState({
      open: true,
      practitioner,
      approvalRole,
      actionType,
      loading: false,
    })
  }

  const closeDialog = () => {
    setDialogState({
      open: false,
      practitioner: null,
      approvalRole: null,
      actionType: null,
      loading: false,
    })
  }

  const submitApproval = async (remarks, specializations = [], approvedTherapyDisciplines = null) => {
    if (!remarks?.trim()) {
      onError?.(new Error('Remarks are required'))
      return
    }

    setDialogState((prev) => ({ ...prev, loading: true }))

    try {
      const { practitioner, approvalRole } = dialogState

      const payload = {
        mentorId: practitioner.id,
        remarks,
        serviceDetail: buildServiceDetailsMap(approvalRole, specializations),
      }
      // Only include disciplines on the therapist approval path. The backend ignores them for
      // doctor / screener, but sending null avoids cluttering the payload.
      if (approvedTherapyDisciplines !== null && approvedTherapyDisciplines !== undefined) {
        payload.approvedTherapyDisciplines = approvedTherapyDisciplines
      }

      const apiUrl = APPROVAL_APIS[approvalRole]
      const resp = await putSPDataWithParams(apiUrl, payload)

      if (resp.status === 200 && isCommonResponseSuccessfulV2(resp)) {
        onSuccess?.()
        closeDialog()
      } else {
        throw new Error(resp?.response?.data?.data?.cause || 'Approval failed')
      }
    } catch (error) {
      setDialogState((prev) => ({ ...prev, loading: false }))
      console.log({ error })
      onError?.(error)
    }
  }

  const submitDisapproval = async (remarks, specializations = []) => {
    if (!remarks?.trim()) {
      onError?.(new Error('Remarks are required'))
      return
    }

    setDialogState((prev) => ({ ...prev, loading: true }))

    try {
      const { practitioner, approvalRole } = dialogState

      const payload = {
        mentorId: practitioner.id,
        remarks,
        serviceDetail: buildServiceDetailsMap(approvalRole, specializations),
      }

      const apiUrl = DISAPPROVAL_APIS[approvalRole]
      const resp = await putSPDataWithParams(apiUrl, payload)

      if (resp.status === 200 && isCommonResponseSuccessfulV2(resp)) {
        onSuccess?.()
        closeDialog()
      } else {
        throw new Error(resp?.response?.data?.data?.cause || 'Disapproval failed')
      }
    } catch (error) {
      setDialogState((prev) => ({ ...prev, loading: false }))
      console.log({ error })
      onError?.(error)
    }
  }

  const onSubmitAction = useMemo(() => {
    switch (dialogState.actionType) {
      case APPROVAL_DISAPPROVAL_DIALOG_TYPES.APPROVE:
        return submitApproval
      case APPROVAL_DISAPPROVAL_DIALOG_TYPES.DISAPPROVE:
        return submitDisapproval
      default:
        return
    }
  }, [dialogState.actionType])

  return {
    dialogState,
    openDialog,
    closeDialog,
    submitApproval,
    onSubmitAction,
  }
}
